import React from 'react';
import { Calendar, MapPinned, Users } from 'lucide-react';

function RoutePlannerSidebar({
  selectedDate,
  setSelectedDate,
  strategy,
  setStrategy,
  serviceMinutes,
  setServiceMinutes,
  maxPackagesDefault,
  setMaxPackagesDefault,
  useGoogle,
  setUseGoogle,
  preview,
  selectedCount,
  onOpenDrivers,
  onLoadLatestPlan,
}) {
  return (
    <aside className="space-y-4">
      <section className="rounded-lg border border-slate-200 bg-white p-4">
        <div className="mb-3 flex items-center gap-2">
          <Calendar className="h-5 w-5 text-brand-primary" />
          <h2 className="font-bold text-slate-900">Fecha y reglas</h2>
        </div>
        <label className="mb-3 block text-sm font-semibold text-slate-600">
          Fecha
          <input
            type="date"
            value={selectedDate}
            onChange={(event) => setSelectedDate(event.target.value)}
            className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2"
          />
        </label>
        <label className="mb-3 block text-sm font-semibold text-slate-600">
          Estrategia
          <select
            value={strategy}
            onChange={(event) => setStrategy(event.target.value)}
            className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2"
          >
            <option value="use_all_available">Usar todos los disponibles</option>
            <option value="use_fewer_drivers">Usar menos conductores</option>
          </select>
        </label>
        <div className="grid grid-cols-2 gap-3">
          <NumberField label="Servicio min" value={serviceMinutes} onChange={setServiceMinutes} />
          <NumberField label="Max default" value={maxPackagesDefault} onChange={setMaxPackagesDefault} />
        </div>
        <label className="mt-3 flex items-center gap-2 text-sm font-semibold text-slate-700">
          <input type="checkbox" checked={useGoogle} onChange={(event) => setUseGoogle(event.target.checked)} />
          Google Route Optimization
        </label>
      </section>

      <section className="rounded-lg border border-slate-200 bg-white p-4">
        <div className="mb-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <MapPinned className="h-5 w-5 text-brand-green" />
            <h2 className="font-bold text-slate-900">Entregas</h2>
          </div>
          <span className="rounded-full bg-slate-100 px-2 py-1 text-xs font-bold text-slate-600">
            {preview?.summary?.total || 0}
          </span>
        </div>
        <div className="grid grid-cols-3 gap-2 text-center text-xs">
          <Metric label="Sin ubic." value={preview?.summary?.missing_location || 0} tone="warn" />
          <Metric label="Prioridad" value={preview?.summary?.priority || 0} tone="hot" />
          <Metric label="Drivers" value={selectedCount} tone="ok" />
        </div>
        <button
          onClick={onOpenDrivers}
          className="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-slate-900 px-3 py-2 text-sm font-bold text-white"
        >
          <Users className="h-4 w-4" />
          Conductores disponibles
        </button>
        {preview?.latest_plan && (
          <button
            onClick={onLoadLatestPlan}
            className="mt-2 w-full rounded-lg border border-brand-primary px-3 py-2 text-sm font-bold text-brand-primary"
          >
            Abrir ultimo plan #{preview.latest_plan.id}
          </button>
        )}
      </section>
    </aside>
  );
}

function NumberField({ label, value, onChange }) {
  return (
    <label className="block text-sm font-semibold text-slate-600">
      {label}
      <input
        type="number"
        min="1"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2"
      />
    </label>
  );
}

function Metric({ label, value, tone }) {
  const classes = {
    warn: 'bg-amber-50 text-amber-700',
    hot: 'bg-pink-50 text-brand-primary',
    ok: 'bg-emerald-50 text-brand-green',
  };
  return (
    <div className={`rounded-lg px-2 py-2 ${classes[tone] || 'bg-slate-100 text-slate-600'}`}>
      <div className="text-lg font-bold">{value}</div>
      <div>{label}</div>
    </div>
  );
}

export default RoutePlannerSidebar;
